import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiCheck, FiAlertCircle, FiRotateCcw } = FiIcons;
import SafeIcon from '../common/SafeIcon';

export default function Toast({ message, type, action, onActionClick }) {
  const isError = type === 'error';

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 50, opacity: 0 }}
      className="fixed bottom-6 right-6 z-[100]"
    >
      <div className={`flex items-center gap-4 px-4 py-3 rounded-lg shadow-2xl border ${isError ? 'bg-red-950 border-red-800 text-red-200' : 'bg-gray-800 border-indigo-800 text-indigo-100'}`}>
        <div className="flex items-center gap-3">
          <SafeIcon icon={isError ? FiAlertCircle : FiCheck} className="text-xl" />
          <span className="font-medium text-sm">{message}</span>
        </div>
        
        {action && (
          <button 
            onClick={onActionClick}
            className="flex items-center gap-1.5 bg-indigo-600 hover:bg-indigo-500 text-white px-3 py-1 rounded-md text-xs font-bold transition-all ml-2"
          >
            <SafeIcon icon={FiRotateCcw} className="text-[10px]" />
            {action.label}
          </button>
        )}
      </div>
    </motion.div>
  );
}